const CHART_COLORS = {
  alternateGridColor: "#FAFAFA",
  plotLine: {
    color: "#bbbbbb",
  },
  tooltip: {
    backgroundColor: "rgba(255,255,255,0.8)",
  },
};

export default CHART_COLORS;
